import React from 'react';
import {connect} from 'react-redux';
import Const from 'constants';
import {ModeTabs as Puzzle} from 'components/organisms/mode-tabs/components/index';

class ModeTabs extends Puzzle {
    render() {
        const {filters, players} = this.props;

        const mvpQnt = this.calcPlayersQuantityByMode(Const.CAPTAIN_MODE);
        const flexQnt = this.calcPlayersQuantityByMode(Const.FLEX_MODE);

        return (
            <ul className="table-tab">
                {this.getOverallTab({
                    isActive: filters.isModeOverall(),
                    playersQuantity: players.data.playersCount,
                })}
                {this.getCaptainTab({
                    isActive: filters.isModeCaptain(),
                    playersQuantity: mvpQnt,
                    modeName: 'SUPERSTAR',
                })}
                {this.getFlexTab({
                    isActive: filters.isModeFlex(),
                    playersQuantity: flexQnt,
                })}
                {this.getExcludedTab({
                    isActive: filters.isModeExcluded(),
                    playersQuantity: players.data.totalExcludedQnt,
                })}
                {this.getLockTab({
                    isActive: filters.isModeLocked(),
                    playersQuantity: players.data.lockedCount,
                    playersSalary: players.data.lockedSalary,
                })}
            </ul>
        );
    }
}

function mapStatesToProps(state) {
    const {players, filters} = state.playersData;
    return {
        players,
        filters,
    };
}

let Tabs = connect(mapStatesToProps)(ModeTabs);

export {Tabs};
